import SmartImage from "@/components/ui/SmartImage";

/** Typographic fallback used when a story has no image. */
export function StoryTile({
  index,
  title,
  image,
  className,
  w = 640,
  h = 400,
}: {
  index: number;
  title: string;
  image?: string | null;
  className?: string;
  w?: number;
  h?: number;
}) {
  if (image) {
    return (
      <SmartImage src={image} w={w} h={h} alt="" className={className} />
    );
  }
  return (
    <div
      className={`flex items-center justify-center bg-muted ${className ?? ""}`}
      aria-hidden
    >
      <span className="font-display text-6xl text-muted-foreground/40">
        {String(index).padStart(2, "0")}
      </span>
      <span className="sr-only">{title}</span>
    </div>
  );
}
